module.exports = __webpack_public_path__ + "movement-front.jpg?ac0cc1be18f4c9ebd3b00c28d618ecb8";